import React from 'react';

const AppointmentPage = () => {
  return (
    <main>
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Book a Demo
            </h1>
            <p className="text-xl text-text-medium">
              Schedule a time to learn how Aletheia Systems can help protect your institution
            </p>
          </div>

          <div className="bg-white rounded-lg p-4 relative">
            <iframe
              src="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2dyVCYv-Gp_73Q2cOzOseGTsgRLQF01KGkKx-A4ZGcL9BLF2OyBrJyxPWgWxlaj03nuhhfQZgH?gv=true"
              style={{ border: 0 }}
              width="100%"
              height="800"
              frameBorder="0"
              title="Schedule an appointment"
            />

          </div>
        </div>
      </section>
    </main>
  );
};

export default AppointmentPage;
